module.exports = __webpack_public_path__ + "static/syncedinteractions-87c325836b0e628b6412d49f7e1da180.png";